import { Data } from "./data.interface";
import { Tag } from "./tag.model";
import { ActivityLog } from "./activity-log.model";
import * as moment from "moment";
import { MetaData } from "./meta-data.model";

export class Patient implements Data {
  _id?: string;
  patientId: string;
  familyId: string;
  data: Object;
  meta: Object;
  tags: Array<Tag>;
  name: string;
  createdDate: string;
  notes: string;
  activityLog: Array<ActivityLog>;
  visitId?: string;
  eye?: string;
  patId2?: string;
  patId3?: string;
  patId4?: string;
  familyStatus?: FamilyStatus;
}

export enum PatientIdNames {
  patientId = "mactelId",
  patId2 = "aNumber",
  patId3 = "siteId",
  patId4 = "id4",
}

export enum FamilyStatus {
  probandSolo = "probandSolo",
  probandWithFamily = "probandWithFamily",
  familyMember = "familyMember",
  familySolo = "familySolo",
}



// WEBPACK FOOTER //
// ./src/app/models/patient.model.ts